import script from "./order-due-error.vue?vue&type=script&setup=true&lang=js"
export * from "./order-due-error.vue?vue&type=script&setup=true&lang=js"

import "./order-due-error.vue?vue&type=style&index=0&id=d2e7521e&lang=css"

const __exports__ = script;

export default __exports__